import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Pajak Barang ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-full pb-4"
}
const _hoisted_7 = {
  class: "w-full px-4 text-12px xxl:text-14px pb-24 overflow-y-auto",
  style: {"padding-right":"50%"}
}
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-2 w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Kota Asal, Komoditas, dan Periode Aktif tidak boleh sama dengan Pajak Barang yang sudah tersedia pada status aktif. ")
], -1)
const _hoisted_10 = { class: "py-2 w-full" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Kota Asal", -1)
const _hoisted_12 = { class: "py-2 w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Komoditas", -1)
const _hoisted_14 = { class: "py-2 w-full" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Deminimus ")
const _hoisted_17 = { class: "ml-1 relative" }
const _hoisted_18 = { class: "flex flex-row items-center relative w-1/3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " $ ", -1)
const _hoisted_20 = { class: "py-2 w-full flex flex-row" }
const _hoisted_21 = { class: "w-1/3" }
const _hoisted_22 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Biaya Masuk ")
const _hoisted_24 = { class: "ml-1 relative" }
const _hoisted_25 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_27 = { class: "w-1/3" }
const _hoisted_28 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" PPH ")
const _hoisted_30 = { class: "ml-1 relative" }
const _hoisted_31 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_33 = { class: "w-1/3" }
const _hoisted_34 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" PPN ")
const _hoisted_36 = { class: "ml-1 relative" }
const _hoisted_37 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_39 = { class: "py-4 border-t border-gray-lp-400" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }, " Periode Aktif ", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Pajak barang akan aktif sesuai dengan tanggal periode yang dipilih. ", -1)
const _hoisted_42 = { class: "flex flex-row w-full" }
const _hoisted_43 = { class: "w-3/5 py-3 mr-2" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ")
  ])
], -1)
const _hoisted_45 = { class: "flex flex-row w-full" }
const _hoisted_46 = { class: "w-3/5 py-3 ml-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Sampai")
  ])
], -1)
const _hoisted_48 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-2 ml-1"
}
const _hoisted_49 = {
  class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400 mt-4",
  style: {"margin-left":"-35%"}
}
const _hoisted_50 = { class: "py-3" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Pajak Barang ", -1)
const _hoisted_52 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = { class: "capitalize" }
const _hoisted_55 = { class: "py-3" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_57 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_58 = { class: "text-gray-lp-500" }
const _hoisted_59 = { class: "py-3" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Terakhir Diubah ", -1)
const _hoisted_61 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_62 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MultipleSelectCity = _resolveComponent("MultipleSelectCity")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              (_ctx.isSaveable())
                ? (_openBlock(), _createBlock(_component_button_fill, {
                    key: 0,
                    title: "Simpan",
                    onClick: _ctx.onOpenSave,
                    class: "px-8 bg-red-lp-300"
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_button_fill, {
                    key: 1,
                    title: "Simpan",
                    class: "px-8 cursor-default",
                    style: {"background-color":"#a7a8aa","border-color":"#a7a8aa"}
                  }))
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_MultipleSelectCity, {
                        "model-value": _ctx.detailData.goodsTaxOriginCity,
                        disabled: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("input", {
                        value: _ctx.detailData.commodity,
                        placeholder: "e.g 1",
                        type: "text",
                        disabled: "true",
                        class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full"
                      }, null, 8, ["value"])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _createVNode("img", {
                            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenDeminimus(true))),
                            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenDeminimus(false))),
                            src: 
                    _ctx.isOpenDeminimus
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: "Deminimus",
                            message: "Batas minimal harga barang (Deminimus) saat ini adalah 3$ per barang.",
                            footer: "",
                            isArrowBottom: false,
                            style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                          }, null, 512), [
                            [_vShow, _ctx.isOpenDeminimus]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_18, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.deminimus = $event)),
                          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setDeminimus && _ctx.setDeminimus(...args))),
                          placeholder: "e.g 1",
                          type: "text",
                          class: 
                  `py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border ${
                    _ctx.deminimus < 0 ? 'border-red-lp-300' : 'border-gray-lp-400'
                  } focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3`
                
                        }, null, 34), [
                          [_vModelText, _ctx.deminimus]
                        ]),
                        _hoisted_19
                      ])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("div", _hoisted_24, [
                            _createVNode("img", {
                              onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOpenBiayaMasuk(true))),
                              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onOpenBiayaMasuk(false))),
                              src: 
                      _ctx.isOpenBiayaMasuk
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                              alt: ""
                            }, null, 40, ["src"]),
                            _withDirectives(_createVNode(_component_Tooltip, {
                              title: "Biaya Masuk",
                              message: "Tarif Bea Masuk (BM) akan dikenakan untuk barang dengan nilai Deminimus lebih dari 3$ sebesar 7,5% kecuali 4 komoditi (Tas, Sepatu, Produk Tekstil) akan dikenakan 15% - 20%, 25% - 30%, dan 15% - 25%.",
                              footer: "",
                              isArrowBottom: false,
                              style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                            }, null, 512), [
                              [_vShow, _ctx.isOpenBiayaMasuk]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_25, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.biayaMasuk = $event)),
                            onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setBiayaMasuk && _ctx.setBiayaMasuk(...args))),
                            placeholder: "e.g 20",
                            type: "text",
                            class: 
                    `py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border ${
                      _ctx.biayaMasuk < 0
                        ? 'border-red-lp-300'
                        : 'border-gray-lp-400'
                    } focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3`
                  
                          }, null, 34), [
                            [_vModelText, _ctx.biayaMasuk]
                          ]),
                          _hoisted_26
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _createVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode("div", _hoisted_30, [
                            _createVNode("img", {
                              onMouseenter: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onOpenPPH(true))),
                              onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onOpenPPH(false))),
                              src: 
                      _ctx.isOpenPPH
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                              alt: ""
                            }, null, 40, ["src"]),
                            _withDirectives(_createVNode(_component_Tooltip, {
                              title: "PPH",
                              message: "Tarif Pajak Penghasilan (PPh) akan dikenakan sebesar 7,5% - 10% untuk barang dengan nilai Deminimus lebih dari 3$.",
                              footer: "",
                              isArrowBottom: false,
                              style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                            }, null, 512), [
                              [_vShow, _ctx.isOpenPPH]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_31, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.PPH = $event)),
                            onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.setPPH && _ctx.setPPH(...args))),
                            placeholder: "e.g 10",
                            type: "text",
                            class: 
                    `py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border ${
                      _ctx.PPH < 0 ? 'border-red-lp-300' : 'border-gray-lp-400'
                    } focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3`
                  
                          }, null, 34), [
                            [_vModelText, _ctx.PPH]
                          ]),
                          _hoisted_32
                        ])
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _createVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createVNode("div", _hoisted_36, [
                            _createVNode("img", {
                              onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onOpenPPN(true))),
                              onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onOpenPPN(false))),
                              src: 
                      _ctx.isOpenPPN
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                              alt: ""
                            }, null, 40, ["src"]),
                            _withDirectives(_createVNode(_component_Tooltip, {
                              title: "PPN",
                              message: "Besaran Pajak Pertambahan Nilai (PPN) adalah 10%.",
                              footer: "",
                              isArrowBottom: false,
                              style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                            }, null, 512), [
                              [_vShow, _ctx.isOpenPPN]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_37, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.PPN = $event)),
                            onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.setPPN && _ctx.setPPN(...args))),
                            placeholder: "e.g 10",
                            type: "text",
                            class: 
                    `py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border ${
                      _ctx.PPN < 0 ? 'border-red-lp-300' : 'border-gray-lp-400'
                    } focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3`
                  
                          }, null, 34), [
                            [_vModelText, _ctx.PPN]
                          ]),
                          _hoisted_38
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _hoisted_41,
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode("div", _hoisted_45, [
                          _createVNode(_component_DatePicker, {
                            modelValue: new Date(_ctx.detailData.startPeriod),
                            disabled: true
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode("div", {
                          class: 
                  `flex flex-row w-full ${_ctx.invalidEndDate && 'date-error'}`
                
                        }, [
                          _createVNode(_component_DatePicker, {
                            modelValue: _ctx.periodeEnd,
                            onSelected: _ctx.inputDateEnd,
                            minDate: _ctx.tomorrow,
                            maxDate: new Date(_ctx.detailData.endPeriod)
                          }, null, 8, ["modelValue", "onSelected", "minDate", "maxDate"])
                        ], 2),
                        (_ctx.invalidEndDate)
                          ? (_openBlock(), _createBlock("span", _hoisted_48, "Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode("div", _hoisted_52, [
                      _createVNode("div", _hoisted_53, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300 text-green-lp-200'
                      : _ctx.detailData.status.toLowerCase() === 'expired'
                      ? 'bg-red-lp-600 text-red-lp-500'
                      : 'bg-yellow-lp-200 text-yellow-lp-100'
                  }`
                
                        }, [
                          _createVNode("span", _hoisted_54, _toDisplayString(_ctx.detailData.status), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode("div", _hoisted_57, _toDisplayString(_ctx.formatDate(_ctx.detailData.createdAt)), 1),
                    _createVNode("div", _hoisted_58, _toDisplayString(_ctx.detailData.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, _toDisplayString(_ctx.formatDate(_ctx.detailData.updatedAt || _ctx.detailData.createdAt)), 1),
                    _createVNode("div", _hoisted_62, _toDisplayString(_ctx.detailData.updatedBy), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Perubahan Berhasil Disimpan !",
      message: `Pajak Barang “${_ctx.detailData.commodity}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Pajak Barang",
      message: 
      `Anda yakin ingin menyimpan perubahan Pajak Barang “${_ctx.detailData.city} - ${_ctx.detailData.commodity}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.handleErrorClose,
      title: "Terjadi kesalahan",
      message: _ctx.errorCause,
      image: "warning",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "message"]), [
      [_vShow, _ctx.isErrorEdit]
    ])
  ], 64))
}